import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  getPlatformFeedback(params) {
    return axios.post('/api/rendering/admin/front/user/feedback/queryPlatformFeedbackList', params)
  },
  getOfficialFeedback(params) {
    return axios.post('/api/rendering/admin/front/user/feedback/queryWebsiteFeedbackList', params)
  },
  exportPlatformFeedback(params) {
    return exportAxios('/api/rendering/admin/front/user/feedback/exportPlatformFeedback', params)
  },
  exportOfficialFeedback(params) {
    return exportAxios('/api/rendering/admin/front/user/feedback/exportWebsiteFeedback', params)
  },
  // 查询问卷
  queryQuestionnaire(params) {
    return axios.post('/api/rendering/admin/front/productResearch/queryQuestionnaire', params)
  },
  // 新增问卷
  addQuestionnaire(params) {
    return axios.post('/api/rendering/admin/front/productResearch/addQuestionnaire', params)
  },
  // 删除问卷
  deleteQuestionnaire(params) {
    return axios.post('/api/rendering/admin/front/productResearch/deleteQuestionnaire', params)
  },
  // 编辑问卷
  updateQuestionnaire(params) {
    return axios.post('/api/rendering/admin/front/productResearch/updateQuestionnaire', params)
  },
  // 查询所有项目
  queryProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/queryProject', params)
  },
  // 修改项目
  updateProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/updateProject', params)
  },
  // 删除项目
  deleteProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/deleteProject', params)
  },
  // 回收项目
  recycleProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/recycleProject', params)
  },
  // 新增项目
  addProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/addProject', params)
  },
  // 上传用户excel
  uploadUserExcel(params) {
    return axios.post('/api/rendering/admin/front/productResearch/uploadUserExcel', params)
  },
  // 查看项目涉及用户具体数据
  queryUserOfProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/queryUserOfProject', params)
  },
  // 查询所有问卷名称和id
  queryQuestionnaireIdAndName(params) {
    return axios.post('/api/rendering/admin/front/productResearch/queryQuestionnaireIdAndName', params)
  },
}
